module.exports = __webpack_public_path__ + "static/media/backWave14.4ecde0e0.svg";